export default __webpack_public_path__ + "static/media/icon_radio_button_checked.2cb1c558.svg";